module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/VETERINARY SCIENCE-dcd9d19da21795562ae4aaad7f5f48b7.png";